import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconImageRequest = ({ color = 'var(--color-semantic-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M13.6259 12.8047C13.3793 12.5625 12.9774 12.5625 12.7268 12.8047L11.2627 14.2422L8.53356 11.5625C8.2869 11.3203 7.88508 11.3203 7.63444 11.5625L3.17863 15.9375C2.93197 16.1836 2.93595 16.5781 3.18659 16.8203C3.30196 16.9336 3.4611 16.9961 3.62421 17H16.3551C16.7052 17.0039 16.9916 16.7227 16.9956 16.3789C16.9956 16.211 16.928 16.0508 16.8086 15.9297L13.6259 12.8047Z" fill={color}/>
            <path opacity="0.4" d="M12.9096 8.75C13.9643 8.75 14.8193 7.91053 14.8193 6.875C14.8193 5.83947 13.9643 5 12.9096 5C11.855 5 11 5.83947 11 6.875C11 7.91053 11.855 8.75 12.9096 8.75Z" fill={color}/>
            <rect opacity="0.4" x="1" y="1" width="18" height="18" rx="3" stroke={color} strokeWidth="2"/>
        </svg>
    </div>
);

export default IconImageRequest;
